export const APP = '/';

export const GDPR_ROUTE = `${APP}gdpr`;

export const ACCOUNT_ROUTE = `${APP}ucet`;

export const AUTH = `${APP}auth`;
export const RESET_PASSWORD = `${AUTH}/reset-password`;
export const SIGN_IN = `${AUTH}/prihlaseni`;
export const SIGN_OUT_ROUTE = `${AUTH}/odhlaseni`;
export const SIGN_UP = `${AUTH}/registrace`;
export const SIGN_UP_COMPLETE = `${SIGN_UP}/hotovo`;

export const PROGRAM_ROUTE= `${APP}program`;
export const SERVICE_ROUTE = `${APP}sluzba`;
export const TOREAD_ROUTE = `${APP}prectete-si`;
export const CONTACT_ROUTE = `${APP}kontakty`;
